/* eslint-disable */

import React from 'react';
import './Tag.css';
import Headers from '../Headers';
// import pubsub from 'pubsub-js';
// import $ from 'jquery';
import FormElement from './FormElement';
import Singleton from '../../sock';
import { ToastContainer } from 'react-toastr';


class TagWriter extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            bookno:""
        }
    }

    componentWillMount(){
        console.log('tagwriterl mount');
        this.sock = Singleton.getInstance();
    }
    
    componentDidMount(){
        this.sock.onmessage = (msg) => {
            //for java
            if(typeof(msg.data) === 'string'){
                console.log('string it is')
              this.fetchcode(msg.data)
            }
            // for python
            else{
                FileReader.prototype.that = this;
                var reader = new FileReader();
                reader.onload = function() {
                    reader.__proto__.that.fetchcode(reader.result)
                }
                reader.readAsText(msg.data)
            }
        }
        this.sock.onerror = (err) => {
            console.log(err);
            this.refs.container.error("Could not connect to ThingMagic. Please check your connection and refresh");
            
        }
    
    }
    componentWillUnmount(){
        console.log('tagwriter unmount connection will close now');
        Singleton.closeSocket(this.sock);
    }

    fetchcode(bookId){
        console.log('tag coming from jar is ',bookId);
        var tag = '';
        // if(bookId.includes('M') || bookId.includes('B') || bookId.includes('P') ||bookId.includes('C')||bookId.includes('W')){
        //     tag = bookId;
        // }else{
        //     tag = 'M'+bookId;
        //     console.log('modified tag is ',tag)

        // }
        this.setState({bookno:bookId});
    }

    render(){
        return(

            <div >
            <Headers hname = "Tag Writer" />

                <div className = "container">
                <ToastContainer 
                    ref = "container"    
                    className="toast-top-right"
                />
                    <FormElement code = {this.state.bookno}
                        sock = {this.sock}/>
                </div>
                {/* onChange = { this.handleChange} */}
            </div>
            
        )
    }
}
    

export default TagWriter;


// WEBPACK FOOTER //
// ./src/Components/Tag Writer/TagWriter.js